var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GenericTest',{attrs:{"test":_vm.test,"test_id":_vm.test_id,"answer":_vm.answer,"col_size":6,"label_size":6,"input_size":6,"semester":_vm.semester,"previous_answer":_vm.previous_answer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }